import { defineComponent as _defineComponent } from 'vue'
import type { BuyboxPresentationType } from '@/stores/pinia/useUserStore';
import type { SponsoredAdFragment } from '@/features/sponsored-recommendations/graphql/fragments/SponsoredAd.fragment';
import type { WatchlistTitleGraphqlFragment } from '@/components/watchlist/graphql/fragments/WatchlistTitle.fragment';
import type { TvShowTrackingTitleFragment } from '@/components/watchlist/graphql/fragments/TVShowTrackingTitle.fragment';

import GridBuyBox from '@/features/buybox/components/grid/GridBuyBox.vue';
import BaseModal from '@/components/modals/vfm/BaseModal.vue';

import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WatchNowModal',
  props: {
    title: null,
    defaultPresentationType: null,
    isNextEpisodeButton: { type: Boolean, default: false },
    sponsoredAd: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { title: WatchlistTitleGraphqlFragment['node'] | TvShowTrackingTitleFragment['node'], defaultPresentationType: BuyboxPresentationType, isNextEpisodeButton: boolean, sponsoredAd: SponsoredAdFragment | undefined };



const titleToDisplay = computed(() => {
	if (props.isNextEpisodeButton && 'watchNextEpisode' in props.title && props.title.watchNextEpisode) {
		return props.title.watchNextEpisode;
	}

	return props.title;
});

const seasonNumber = computed(() => {
	if (titleToDisplay.value.__typename === 'Episode') {
		return titleToDisplay.value?.content.seasonNumber;
	}

	return null;
});

const episodeNumber = computed(() => {
	if (titleToDisplay.value.__typename === 'Episode') {
		return titleToDisplay.value?.content.episodeNumber;
	}

	return null;
});

const headerTitle = computed(() => {
	if (titleToDisplay.value.__typename === 'Episode') {
		return `${titleToDisplay.value?.content.title} - S${seasonNumber.value}E${episodeNumber.value}`;
	}

	return titleToDisplay.value.content.title;
});

const showDetails = computed(() => {
	if (titleToDisplay.value.__typename === 'Episode') {
		return {
			id: props.title.id,
			objectId: props.title.objectId,
			objectType: props.title.objectType,
			title: props.title.content.title,
		};
	}

	// @ts-expect-error TODO update graphql type to include Seasons
	if (titleToDisplay.value.__typename === 'Season') {
		// @ts-ignore
		const show = props.title.show;

		return {
			id: show.id,
			objectId: show.objectId,
			objectType: show.objectType,
			title: show.content.title,
		};
	}

	return null;
});

const watchlistEntryV2 = ref<{ createdAt: string } | null>(null);
// When a modal is created its lose props references and props are not updating, so we use the flag to be sure that
// prop title is align with GraphQL cache
const isTitleAlignedWithCache = ref(true);

const updatedTitle = computed(() => ({
	...props.title,
	watchlistEntryV2: isTitleAlignedWithCache.value ? props.title.watchlistEntryV2 : watchlistEntryV2.value,
}));

function onWatchlistToggle(createdAt: string | null) {
	isTitleAlignedWithCache.value = false;
	watchlistEntryV2.value = createdAt ? { createdAt } : null;
}

return { __sfc: true,props, titleToDisplay, seasonNumber, episodeNumber, headerTitle, showDetails, watchlistEntryV2, isTitleAlignedWithCache, updatedTitle, onWatchlistToggle, GridBuyBox, BaseModal }
}

})